export default "__VITE_ASSET__59608ac7__"